import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SystemEnvEntity } from '@nk/data-entities-lib';
import { APP_ENV_CONFIG_TOKEN, EnvironmentKey } from '@nk/utils-lib';

@Component({
  selector: 'nk-system-env-banner',
  imports: [],
  templateUrl: './system-env-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SystemEnvBannerComponent {
  public systemEnv = input<SystemEnvEntity>();
  public environmentKey: EnvironmentKey;
  public envColors: Record<EnvironmentKey, string> = {
    local: 'gray',
    test: 'yellow',
    beta: 'red',
    dev: 'success',
    pre: 'dark-red',
    prod: '',
  };
  private _appEnvConfig = inject(APP_ENV_CONFIG_TOKEN);

  constructor() {
    if (this._appEnvConfig?.environmentKey !== 'prod') {
      this.environmentKey = this._appEnvConfig.environmentKey;
    }
  }
}
